<template>
<div class="chapter">
<div class="inner_page">
<p class="chap_title"><span>Praise for the Writing of Mildred Pitts Walter</span></p>
<p class="center"><span><i><b>Because We Are</b></i></span></p>
<p class="center-a"><span>A Coretta Scott King Honor Book</span></p>
<p class="center-a"><span>A Parents’ Choice Award Book for Literature</span></p>
<p class="normal1">“Walter draws readers into a complex situation with finely paced writing, good integration of themes, and an understanding of the feelings of young men and women.” —<i>School Library Journal</i></p>
<p class="center"><span><i><b>The Girl on the Outside</b></i></span></p>
<p class="center-a"><span>A Christian Science Monitor Best Book</span></p>
<p class="center-a"><span>A Notable Children’s Trade Book in the Field of Social Studies</span></p>
<p class="normal1">“[Walter] re-creates the tenor of the times from both black and white perspectives and gives the incident immediacy for today’s younger teens …” —<i>Booklist</i></p>
<p class="normal1">“We are moved … by the courage required of these children and their parents …” —<i>School Library Journal</i></p>
<p class="normal1">“A moving, dramatic re-creation of the 1957 integration of a Little Rock high school as seen through the eyes of a black girl and a white girl.” —<i>Booklist</i></p>
<p class="normal1">“A vivid story … written with insight and compassion, its characters fully developed, its converging lines nicely controlled.” —<i>Bulletin of the Center for Children’s Books</i></p>
<p class="center"><span><i><b>Second Daughter</b></i></span></p>
<p class="normal1">“Based on a real case, this admirable historical novel is unique for the perspective it lends to the Revolution and its profound impact on the lives of all Americans.” —<i>Kirkus Reviews</i></p>
<p class="center"><span><i><b>Trouble’s Child</b></i></span></p>
<p class="center-a"><span>A Coretta Scott King Honor Book</span></p>
<p class="normal1">“Walter immerses readers in Martha’s internal struggle, holding their attention to the last page. The quickly paced text utilizes the native dialect, further adding to the aura of the isolated island setting as Walter shows how ritual and superstition dominate.… While Martha’s particular problems are unique, adolescent readers will easily empathize with her predicament of feeling confused by the pull from so many different directions at this stage of life.” —<i>School Library Journal</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm01.vue?3e9526ba